/**
 * When working locally we use the REACT_APP_ environment variables.
 * When building for production, we inject the variables via the
 * `window.__DYNAMIC_JS_VARS`. This allows us to perform dynamic configuration
 * at runtime via nginx.
 *
 * See ops/docker-entrypoint.sh for more details.
 */
declare global {
  interface Window {
    __DYNAMIC_JS_VARS?: any;
  }
}
let injectedConfig: any = {};
if (window?.__DYNAMIC_JS_VARS) {
  injectedConfig = window.__DYNAMIC_JS_VARS;
}
export default {
  DRIVER_SCHEDULING_API:
    injectedConfig?.driverSchedulingApi ||
    process.env.REACT_APP_DRIVER_SCHEDULING_API ||
    'https://driver-scheduling-api.gopuff.com',
  OKTA: {
    clientId: injectedConfig?.oktaClientId || process.env.REACT_APP_OKTA_CLIENT_ID,
    issuer: injectedConfig?.oktaIssuer || process.env.REACT_APP_OKTA_ISSUER,
    redirectUri: injectedConfig?.oktaRedirect || process.env.REACT_APP_OKTA_REDIRECT,
    scopes: ['openid', 'profile', 'email', 'groups'],
    pkce: true,
  },
  DISPLAY_MOPED: JSON.parse(process.env.REACT_APP_DISPLAY_MOPED || 'true'),
};
